/** un objet léger pour stocker les données des FDVs dans la matrice */
export class FdvData {
    dataKind?: string;
    label: string;
    rawValue: string;
    sortKey: Object;
    pairs?: Map<string, string>;
}